import {Contact,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {Stack} from '@mantine/core';


export const Profile = ({record}: { record: Contact }) => {

    const properties = [
        {
            label: 'First Name',
            value: record.firstName as string,
            span: 12,
        },
        {
            label: 'Last Name',
            value: record.lastName as string,
            span: 12,
        },
        {
            label: 'Email',
            value: record.email as string,
            span: 12,
        },
        {
            label: 'Phone',
            value: record.phone as string,
            span: 12,
        },
        {
            label: 'Company',
            value: record.company as string,
            span: 12,
        },
        {
            label: 'Position',
            value: record.position as string,
            span: 12,
        },
        {
            label: 'Notes',
            value: record.notes as string,
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created By',
            value: record.createdByUsername || 'n/a',
            rbac: rbacActions.UpdateContact,
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        }, {
            label: 'Managed By',
            value: record.managedByUsername || 'n/a',
            rbac: rbacActions.UpdateContact,
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};

